export function formatNumber(value: any): string {
  if (value) {
    const parseValue = parseFloat(value);
    const newData = parseValue.toLocaleString();
    return newData.toString();
  }
  return value;
}

export const splitData = formatNumber;
